function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M12 14c-5.01 0-9.09 3.36-9.09 7.5 0 .28.22.5.5.5h17.18c.28 0 .5-.22.5-.5 0-4.14-4.08-7.5-9.09-7.5zm4.72-3.65l-.96-.96c.5-.75.79-1.65.79-2.62A4.77 4.77 0 0011.78 2C9.15 2 7 4.14 7 6.77c0 2.63 2.14 4.77 4.77 4.77.97 0 1.87-.29 2.62-.79l.96.96c.19.19.44.28.68.28.25 0 .5-.09.68-.28.38-.37.38-.98.01-1.36z"
})));